module.exports = __webpack_public_path__ + "img/ic-location-blue.5827d1ee.svg";